import { createSlice } from "@reduxjs/toolkit";

const rootSlice = createSlice({
  name: "root",
  initialState: {
    loading: false,
    portfolioData: null,
    userData: null,
    reload: false,
    errorAlert: false,
  },
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state) => {
      state.loading = false;
    },
    setPortfolioData: (state, action) => {
      state.portfolioData = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    ReloadTrue: (state) => {
      state.reload = true;
    },
    ReloadFalse: (state) => {
      state.reload = false;
    },

    ErrorTrue: (state) => {
      state.errorAlert = true;
    },
    ErrorFalse: (state) => {
      state.errorAlert = false;
    },

  },
});

export default rootSlice.reducer;
export const {
  setPortfolioData,
  hideLoading,
  showLoading,
  ReloadTrue,
  ReloadFalse,
  ErrorTrue,
  ErrorFalse,
  setUserData,
} = rootSlice.actions;
